import { PRICE_MODE_OPTIONS, RETAILER_OPTIONS } from "./catalogFilters";

const VALID_RETAILERS = new Set(RETAILER_OPTIONS.map((o) => o.id));
const VALID_PRICE_MODES = new Set(PRICE_MODE_OPTIONS.map((o) => o.id));

// In-memory only: survives SPA back/forward, clears on full page refresh.
let homeQuickCompareMemory = null;

export function isOfferModeFromSearchParams(searchParams) {
  if (!searchParams) return false;
  return (
    searchParams.get("offer") === "true" ||
    searchParams.get("price_mode") === "offer_loyalty"
  );
}

export function applyOfferModeToSearchParams(searchParams, isOfferMode) {
  const next = new URLSearchParams(searchParams || "");
  if (isOfferMode) {
    next.set("offer", "true");
    next.set("price_mode", "offer_loyalty");
  } else {
    next.delete("offer");
    next.delete("price_mode");
  }
  return next;
}

export function getHomeQuickCompareMemory() {
  if (!homeQuickCompareMemory) return null;
  const retailer = VALID_RETAILERS.has(homeQuickCompareMemory.retailer)
    ? homeQuickCompareMemory.retailer
    : "all";
  const priceMode = VALID_PRICE_MODES.has(homeQuickCompareMemory.priceMode)
    ? homeQuickCompareMemory.priceMode
    : "base";
  return { retailer, priceMode };
}

export function setHomeQuickCompareMemory({ retailer, priceMode }) {
  homeQuickCompareMemory = {
    retailer: VALID_RETAILERS.has(retailer) ? retailer : "all",
    priceMode: VALID_PRICE_MODES.has(priceMode) ? priceMode : "base",
  };
}

export function clearHomeQuickCompareMemory() {
  homeQuickCompareMemory = null;
}

export function loadHomeQuickCompareTabs() {
  return getHomeQuickCompareMemory() || { retailer: "all", priceMode: "base" };
}

export function saveHomeQuickCompareTabs({ retailer, priceMode }) {
  setHomeQuickCompareMemory({ retailer, priceMode });
}
